(function (jQuery) {
	"use strict";

	function PasswordToggle() {
		var fn = {
			init: function() {
				var toggles = jQuery('.text-field__password-toggle');
                var forms = toggles.parents('form');

                toggles.on('click', fn.onClick);
                forms.on('submit', fn.onSubmit);
			},

            onClick: function(e) {
                e.preventDefault();
                e.stopPropagation();
                var field = jQuery(this).siblings('input')[0];
                if (field.type === 'password') {
                    field.type = 'text';
                    field.setAttribute('data-password-changed', 'true');
                    jQuery(this).addClass('is-shown');
                } else {
                    field.type = 'password';
                    field.removeAttribute('data-password-changed');
                    jQuery(this).removeClass('is-shown');
                }
            },

            /**
             * Return the fields to password fields for improved security on submit
             * @see https://technology.blog.gov.uk/2021/04/19/simple-things-are-complicated-making-a-show-password-option/
             */
            onSubmit: function()
            {
                var fields = jQuery('[data-password-changed]');
                fields.each(function(i, elem) {
                    elem.type = 'password';
                    elem.removeAttribute('data-password-changed');
                    jQuery(elem).siblings('.text-field__password-toggle').removeClass('is-shown');
                });
            }
		}

        jQuery(fn.init);
	}

	new PasswordToggle();
})(jQuery);